var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessageIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.23077 0.307739C1.44738 0.307739 0 1.75512 0 3.53851V16.4616C0 18.245 1.44738 19.6924 3.23077 19.6924H24.7692C26.5526 19.6924 28 18.245 28 16.4616V3.53851C28 1.75512 26.5526 0.307739 24.7692 0.307739H3.23077ZM3.23077 2.46159H24.7692C25.3626 2.46159 25.8462 2.94512 25.8462 3.53851V4.07697L14 10.4717L2.15385 4.07697V3.53851C2.15385 2.94512 2.63738 2.46159 3.23077 2.46159ZM2.15385 4.37959L9.18723 9.86543L2.28846 16.9333L10.7025 10.9424L14 13.0628L17.2986 10.9424L25.7115 16.9333L18.8128 9.86543L25.8462 4.37959V16.4616C25.8402 16.6274 25.794 16.7893 25.7115 16.9333C25.5338 17.2833 25.1882 17.5385 24.7692 17.5385H3.23077C2.81185 17.5385 2.46615 17.2833 2.28846 16.9322C2.20617 16.7885 2.15998 16.627 2.15385 16.4616V4.37959Z",
    fill: "#A7A7A7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/messageIcon.60c601890832d71279d2a63f5c976939.svg";
export { ForwardRef as ReactComponent };